export function generateWsAccessId(workspaceAccess) {
    const { workspaceId, databaseId, gridId, viewId } = workspaceAccess;
    return `${workspaceId}${databaseId}${gridId}${viewId}`;
}
